import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { share, map, switchMap } from 'rxjs/operators';
import { AuthService } from '@schoolbelle/api/auth';
import { GroupService } from '@schoolbelle/api/group';
import { LetterTargetService } from '@schoolbelle/api/letter-target';

@Injectable({
  providedIn: 'root'
})
export class SelectLetterTargetsGuard implements CanActivate {
  constructor (
    private auth:AuthService,
    private group:GroupService, 
    private target:LetterTargetService,
  ) {
  }
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
      const group_id:string = next.params.group_id; 
      return this.auth.fetchUser().pipe(
        switchMap(()=>this.group.checkIn(Number(group_id))),
        switchMap(()=>this.target.checkIn()),
        map(()=>true),
        share(),
      )
  }
}
